import css from './exeStatuses.module.scss';

import cx from 'classnames';
import dayjs from 'dayjs';
import { memo } from 'react';

import { parseTimeDuration } from 'core/helpers/text';

type TStatus = {
  label: string;
  lastProbeAt?: string;
  nextProbeAt?: string;
};

function ExeStatuses({
  statuses,
  className,
}: {
  className?: string;
  statuses: TStatus[];
}) {
  return (
    <div className={cx(css.root, className)}>
      {statuses.map(status => (
        <Status key={status.label + Math.random()} status={status} />
      ))}
    </div>
  );
}

export default memo(ExeStatuses);

const Status = ({ status }: { status: TStatus }) => {
  const { label, lastProbeAt, nextProbeAt } = status;

  if (!lastProbeAt || !nextProbeAt) {
    return (
      <div className={css.exeStatus} title={`${label}. New. Ready to repeat`}>
        <div
          className={css.exeStThumb}
          data-status="ready"
          style={{ height: `100%` }}
        />
      </div>
    );
  }

  const distance = dayjs
    .utc(nextProbeAt)
    .diff(dayjs.utc(lastProbeAt), 'minute');
  const upToNow = dayjs.utc(dayjs.utc()).diff(dayjs.utc(lastProbeAt), 'minute');
  const progress = Math.ceil((upToNow / distance) * 100);

  const duration = parseTimeDuration(nextProbeAt);
  const durationStr = `${duration.sign}${duration.count}${duration.label}`;

  const title =
    upToNow >= distance
      ? `${label}. Ready to repeat`
      : `${label}. ${progress}%. ${durationStr}`;

  return (
    <div className={css.exeStatus} title={title}>
      <div
        className={css.exeStThumb}
        data-status={upToNow >= distance ? 'ready' : 'pending'}
        style={{ height: progress < 100 ? `${progress}%` : `100%` }}
      />
    </div>
  );
};
